<div class="p-15">
  <p class="TXT_TITLE">: : Search Alternate Requestor Name : :</p>

  <div *ngIf="isBrowser">
    <form [formGroup]="form" style="margin: 0; padding: 0; width: 100%">
      <input type="hidden" formControlName="HdItemAmount" />
      <input type="hidden" formControlName="DoAction" />

      <div class="form-controls">
        Search By Name&nbsp;&nbsp;
        <input
          type="text"
          [(ngModel)]="groupEmail"
          [ngModelOptions]="{ standalone: true }"
          id="TxtFilter"
          class="UTEXT"
          style="width: 250px"
        />
        <input
          type="button"
          (click)="loadItems()"
          onmouseover="this.style.cursor = 'pointer';"
          id="BtnFilter"
          style="margin-left: 20px; color: black"
          value="SEARCH"
        />
      </div>

      <div class="grid-section" *ngIf="items && items.length > 0">
        <div
          *ngIf="errorMessage"
          style="color: red; text-align: center; padding: 20px"
        >
          <p>{{ errorMessage }}</p>
        </div>

        <nz-table
          #requestItems
          nzBordered
          class="StyleTable"
          [nzData]="items"
          [nzShowPagination]="false"
          [nzPageSize]="items.length"
          *ngIf="!isLoading && !errorMessage"
        >
          <thead>
            <tr>
              <th class="HEADER" style="width: 50px"></th>
              <th class="HEADER" style="width: 50px"></th>
              <th class="HEADER" style="width: 250px">
                {{ constant.groupName }}
              </th>
              <th class="HEADER" style="width: 350px">
                {{ constant.groupMail }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr
              *ngFor="
                let item of requestItems.data;
                let i = index;
                trackBy: trackByIndex
              "
              [ngClass]="{ LST_B: isHovered[i] }"
              (mouseover)="onMouseOver(i)"
              (mouseout)="onMouseOut(i)"
            >
              <td class="ITEM">{{ i + 1 }}</td>
              <td class="ITEM">
                <input
                  type="radio"
                  [id]="'itm' + i"
                  name="caiSelection"
                  [value]="item?.group_mail || ''"
                  [checked]="checkQA(item?.group_mail || '')"
                  (change)="onRadioButtonChange(item)"
                />
              </td>
              <td class="ITEM">{{ item?.group_name || "N/A" }}</td>
              <td class="ITEM">{{ item?.group_mail || "N/A" }}</td>
            </tr>
            <tr *ngIf="!isLoading && !errorMessage && items.length === 0">
              <td
                colspan="4"
                style="text-align: center; padding: 20px; color: #666"
              >
                {{ constant.noCAIData }}
              </td>
            </tr>
          </tbody>
        </nz-table>
      </div>
    </form>
  </div>
</div>
